import React, { useState } from "react"
import PropTypes from "prop-types"

import { Modal } from "@components/Page"

import OrganizationsList from "./OrganizationsList"

const LABEL_TITLE = "Switch To"


const OrganizationsModal = ({ modal }) => {
  const [ isOpen, setIsOpen ] = useState(false)

  modal.current.open = () => setIsOpen(true)

  const onClose = () => {
    setIsOpen(false)
  }

  const modalProps = {
    title: LABEL_TITLE,
    destroyOnClose: true,
    isOpen,
    onClose,
  }

  const organizationListProps = {
    onAfterSwitch: () => onClose()
  }

  return (
    <Modal {...modalProps}>
      <OrganizationsList {...organizationListProps} />
    </Modal>
  )
}

OrganizationsModal.propTypes = {
  modal: PropTypes.shape().isRequired,
}

export default OrganizationsModal
